/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsApplicationBCSInfo {
    getFixupPrototypeFunction() { return AppSecopsApplicationBCSInfo.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsApplicationBCSInfo>): AppSecopsApplicationBCSInfo {
        let obj = Object.assign(new AppSecopsApplicationBCSInfo(), model);
        AppSecopsApplicationBCSInfo.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsApplicationBCSInfo>): AppSecopsApplicationBCSInfo {
        if (!model) return null;
        return AppSecopsApplicationBCSInfo.newInstance(<AppSecopsApplicationBCSInfo> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsApplicationBCSInfo) {
        if (!obj) return;

        models.AppSecopsApplicationBCSInfo.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsApplicationBCSInfo): boolean {
        Object.setPrototypeOf(obj, AppSecopsApplicationBCSInfo.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.bcs_version === undefined) {
            this.bcs_version = 0;
        }
        if (this.bcs_details) {
            models.AppSecopsApplicationV2BCSDetail.fixupPrototype(this.bcs_details);
        }
    }

    /**
     * Application ID
     */
    application_id: string;

    /**
     * BCS question config version
     */
    bcs_version: number;

    /**
     * Current BCS submission
     */
    bcs_details: models.AppSecopsApplicationV2BCSDetail;

}
